import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropdownArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.84766 6.72888C4.01061 6.56339 4.27758 6.56324 4.44043 6.72888L9.64551 12.0238L10.002 12.3861L10.3594 12.0238L15.5645 6.73083C15.7274 6.56551 15.9944 6.56537 16.1572 6.73083C16.3163 6.89254 16.3161 7.15202 16.1572 7.31384L10.3594 13.2103C10.1636 13.4094 9.84243 13.4091 9.64648 13.2103L3.84766 7.31189C3.68858 7.15009 3.68856 6.89066 3.84766 6.72888Z",
		fill: "currentColor",
		stroke: "currentColor"
	})
});
export default SvgDropdownArrow;
